import { useEffect } from "react";
import { useApp } from "@/context/AppContext";

const BRAND = { ar: "سفير بغداد", en: "Safeer Baghdad" };
const DEFAULT_IMAGE = "https://images.pexels.com/photos/20382707/pexels-photo-20382707.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=630&w=1200";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export function useSeo({ title, description, image, type = "website", jsonLd }) {
  const { lang } = useApp();
  useEffect(() => {
    const full = title ? `${title} | ${BRAND[lang]}` : `${BRAND.ar} | ${BRAND.en}`;
    const url = `${window.location.origin}${window.location.pathname}`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", image || DEFAULT_IMAGE);
    setMeta("property", "og:locale", lang === "ar" ? "ar_IQ" : "en_US");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image || DEFAULT_IMAGE);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.setAttribute("rel", "canonical"); document.head.appendChild(canon); }
    canon.setAttribute("href", url);
    let ld = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!ld) { ld = document.createElement("script"); ld.id = "page-jsonld"; ld.type = "application/ld+json"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) ld.remove();
  }, [title, description, image, type, lang, jsonLd]);
}
